<div class="ntm-table-data">
  <mat-card>
    @if (params.toolbar && params.toolbar.title) {
      <mat-toolbar color="primary" class="primary">
        <div id="toolbar-title">{{params.toolbar.title}}</div>
        @if (params.toolbar.actionButton) {
          <div id="action-button-area">
            @if (params.list.permissions.indexOf('Incluir') >= 0) {
              <div class="action-button alternative">
                <button mat-raised-button (click)="setOutput(params.toolbar.actionButton.value)"
                  color="{{ params.toolbar.actionButton.color }}" class="primary-text">{{
                params.toolbar.actionButton.value }}</button>
              </div>
            }
          </div>
        }
        @if (params.toolbar.actionButton2) {
          <div id="action-button-area">
            @if (params.list.permissions.indexOf('Incluir') >= 0) {
              <div class="action-button2 alternative">
                <button mat-raised-button (click)="setOutput(params.toolbar.actionButton2.value)"
                  color="{{ params.toolbar.actionButton2.color }}" class="primary-text">{{
                params.toolbar.actionButton2.value }}</button>
              </div>
            }
          </div>
        }
        @if (params.toolbar.actionButtonToRemove) {
          <div id="action-button-area">
            @if (params.list.permissions.indexOf('Remover') >= 0) {
              <div class="action-button2 alternative">
                <button mat-raised-button (click)="setOutput(params.toolbar.actionButtonToRemove.value)"
                  color="{{ params.toolbar.actionButtonToRemove.color }}" class="primary-text">{{
                params.toolbar.actionButtonToRemove.value }}</button>
              </div>
            }
          </div>
        }
        <div id="toolbar-action">
          @if (params.list.permissions.indexOf('Remover') >= 0 && itensToDeleteIds.length > 0) {
            <a>
              @if (!params.toolbar.outpuDelete) {
                <mat-icon (click)="openDialogToDelete()"
                class="vertical-align-m toolbar-icon">delete</mat-icon>
              }
              @if (params.toolbar.outpuDelete) {
                <mat-icon (click)="setOutput('delete',itensToDeleteIds)"
                class="vertical-align-m toolbar-icon">delete</mat-icon>
              }
            </a>
          }
        </div>
      </mat-toolbar>
    }

    @if (isLoading) {
      <mat-progress-bar mode="indeterminate" style="width: inherit;"></mat-progress-bar>
    }

    @if (isLoading) {
      <div class="loading">
        <mat-spinner class="spinner" diameter="50"></mat-spinner>
        <p>Carregando dados...</p>
      </div>
    }

    @if (!isLoading) {
      <div class="content">
        @if (!disableSearch) {
          <div>
            <mat-accordion>
              <mat-expansion-panel [expanded]="true" disabled>
                <mat-expansion-panel-header>
                  <!-- (click)="make()" -->
                  <mat-panel-title style="color: rgba(0,0,0,.87)">
                    <mat-icon style="margin-top: -3px; margin-right: 5px;">search</mat-icon> Pesquisar
                  </mat-panel-title>
                </mat-expansion-panel-header>
                @if (!advancedSearch) {
                  <mat-form-field style="width: 100%;" [appearance]="appearance">
                    <mat-label>Pesquisar</mat-label>
                    <input matInput (keyup)="applyFilterOnKeyUp($event)" field="key" #searchKey>
                  </mat-form-field>
                }
                @if (advancedSearch && searching) {
                  <div>
                    <form [formGroup]="advancedSearchForm" style="display: flex; flex-wrap: wrap; padding: 0 2rem">
                      @for (item of params?.toolbar?.search; track item) {
                        <div id="grid">
                          @if (item.component == 'autocomplete') {
                            <mat-form-field [appearance]="appearance">
                              <mat-label>{{item.placeholder}}</mat-label>
                              <input placeholder="{{item.placeholder}}" matInput [formControl]="pesquisa[item.field]"
                                [matAutocomplete]="autoActivity" (keyup)="searchAdvance()">
                                <mat-autocomplete #autoActivity="matAutocomplete"
                                  (optionSelected)="searchAdvance(); filterArray(item, $event)">
                                  @for (data of asArray(filteredOptions[item.field] | async); track data) {
                                    <mat-option [value]="data[item.filter]">
                                      {{ data[item.filter] }}
                                    </mat-option>
                                  }
                                </mat-autocomplete>
                              </mat-form-field>
                            }
                            @if (item.component == 'input') {
                              <mat-form-field [appearance]="appearance">
                                <mat-label>{{item.placeholder}}</mat-label>
                                @if (item?.filter == 'cpf_number') {
                                  <input type="text" matInput placeholder="{{item.placeholder}}"
                                    [formControlName]="item.field" [textMask]="{mask: mask.cpf}" (keyup)="searchAdvance(item.field)">
                                } @else {
                                  @if (item?.date) {
                                    <input type="text" matInput placeholder="{{item.placeholder}}"
                                      [formControlName]="item.field" [textMask]="{mask: mask.date}" (keyup)="searchDate(item.field)">
                                  }
                                  @if (!item?.date) {
                                    <input type="text" matInput placeholder="{{item.placeholder}}"
                                      [formControlName]="item.field" (keyup)="searchAdvance()">
                                  }
                                }
                              </mat-form-field>
                            }
                            @if (item.component == 'select') {
                              <mat-form-field [appearance]="appearance">
                                <mat-label>{{item.placeholder}}</mat-label>
                                <mat-select [formControlName]="item.field" (selectionChange)="searchAdvance()">
                                  <mat-option>Selecione</mat-option>
                                  @for (dado of item.options; track dado) {
                                    <mat-option [value]="dado[item.value]">
                                      {{ dado[item.filter] }}
                                    </mat-option>
                                  }
                                </mat-select>
                              </mat-form-field>
                            }
                            @if (item.custom) {
                              <mat-form-field [appearance]="appearance">
                                <mat-label>{{item.placeholder}}</mat-label>
                                <mat-select [formControlName]="item.field" (selectionChange)="searchAdvance()">
                                  <mat-option>Selecione</mat-option>
                                  @for (dado of item.custom; track dado) {
                                    <mat-option [value]="dado[item.value]">
                                      {{ dado[item.filter] }}
                                    </mat-option>
                                  }
                                </mat-select>
                              </mat-form-field>
                            }
                          </div>
                        }
                      </form>
                    </div>
                  }
                </mat-expansion-panel>
              </mat-accordion>
              @if (isDynamicallyLoading) {
                <mat-progress-bar mode="indeterminate" class="dynamic-progress-bar"></mat-progress-bar>
              }
            </div>
          }
          <div>
            @if (total === 0) {
              <p class="no-data">Nenhum dado encontrado.</p>
            }
            @if (total > 0) {
              <mat-table #table [dataSource]="dataSource" matSort (matSortChange)="sortTable($event)">
                <ng-container matColumnDef="id">
                  <mat-header-cell *matHeaderCellDef>
                    @if (params.list.permissions.indexOf('Remover') >= 0 && params?.toolbar?.delete) {
                      <mat-checkbox
                        (change)="toggleAllSelections($event)"
                        [checked]="itensToDeleteIds.length == arraySource.length && arraySource.length > 0">
                      </mat-checkbox>
                    }
                  </mat-header-cell>
                  <mat-cell mat-cell *matCellDef="let element; let i = index">
                    @if (params.list.permissions.indexOf('Remover') >= 0 && params?.toolbar?.delete && checkException(element,'Delete')) {
                      <mat-checkbox (change)="toggleChecked($event, element)" [checked]="isOnSelectedArray(element)"
                        >
                      </mat-checkbox>
                    }
                  </mat-cell>
                </ng-container>
                @for (column of params.list.columns; track column; let i = $index) {
                  <ng-container [matColumnDef]="column.columnDef">
                    <mat-header-cell mat-sort-header [disabled]="column.noSort" *matHeaderCellDef class="padding-cell">
                      {{column.header}}
                      @if (!column.noSort) {
                        <mat-icon style="color: #BDBDBD;">sort</mat-icon>
                      }
                    </mat-header-cell>
                    <mat-cell *matCellDef="let element">
                      @if (column.activateLever) {
                        <mat-slide-toggle [checked]="column.status(element)"
                        (change)="setOutput(column.action,element)"></mat-slide-toggle>
                      }
                      @if (column.btnName && !column.cell(element)) {
                        <button mat-raised-button class="associate-btn ascent"
                          (click)="onAssociateApplications(element.id)">{{
                        column.btnName }}</button>
                      }
                      @if (column.statusCoursesColumn) {
                        <div>
                          @for (statusCourse of element.courses_students; track statusCourse) {
                            <div class="course-status">
                              {{statusCourse.course.description}}
                              <mat-select class="courseStatus" [value]="statusCourse.status_id" placeholder="Status"
                                (selectionChange)="updateCourseStatus(element.id, statusCourse.course.id, $event)">
                                @for (status of statusArray; track status) {
                                  <mat-option [value]="status.id">
                                  {{status.description}}</mat-option>
                                }
                              </mat-select>
                              <br><br><br>
                            </div>
                          }
                        </div>
                      }
                      @if (!column.checkBoxColumn && !column.hexadecimalColumn && !column.statusCoursesColumn && !column.tip) {
                        <div
                        [innerHtml]="column.cell(element)"></div>
                      }
                      @if (column.tip) {
                        <div [matTooltip]="column.cell(element)" class="profile-tooltip">
                          @if (column.cell(element)) {
                            <mat-icon class="info">info</mat-icon>
                          }
                        </div>
                      }
                      @if (column.hexadecimalColumn) {
                        <div
                          [ngStyle]="{background:column.cell(element), color: column.cell(element), display: 'block', width: '5rem', border: '1px solid black'}"
                        [innerHtml]="column.cell(element)"></div>
                      }
                      @if (column.checkBoxColumn) {
                        <div class="profile-check-boxes">
                          <mat-checkbox class="list-item" [disabled]="params.list.disableCheckBoxes"
                            [checked]="column.cell(element)">
                          </mat-checkbox>
                        </div>
                      }
                    </mat-cell>
                  </ng-container>
                }
                <ng-container matColumnDef="updated_at_c">
                  <mat-header-cell *matHeaderCellDef>
                  Ações</mat-header-cell>
                  <mat-cell mat-cell *matCellDef="let element">
                    @if (params.list.view) {
                      <a (click)="onClickEdit(params.list.view.route, element)" matTooltip="Ver">
                        <mat-icon class="settings">settings</mat-icon>
                      </a>
                    }
                    @if (params.list.edit && !params.list.edit.hide && params.list.permissions.indexOf('Editar') >= 0) {
                      <a
                        (click)="onClickEdit(params.list.edit.route, element)" matTooltip="Editar">
                        <mat-icon class="edit">edit</mat-icon>
                      </a>
                    }
                    @if (params.list.resend) {
                      <a (click)="openDialogToReSend(params.list.resend.route, element)">
                        @if (element.invite_status_id == 1) {
                          <mat-icon class="mail" matTooltip="Re-enviar">mail</mat-icon>
                        }
                        @if (element.invite_status_id != 1) {
                          <mat-icon class="mail">mail_outline</mat-icon>
                        }
                      </a>
                    }
                    @if (params.list.modalView) {
                      <a (click)="openCoverSheet(element)" matTooltip="Ver">
                        <mat-icon class="remove_red_eye">remove_red_eye</mat-icon>
                      </a>
                    }
                    @if (params.list.modalPreview) {
                      <a (click)="openEvaluatorManual(element)" matTooltip="Ver">
                        <mat-icon class="remove_red_eye">remove_red_eye</mat-icon>
                      </a>
                    }
                    @if (params.list.examPreview) {
                      <a (click)="openExam(element)" matTooltip="Ver">
                        <mat-icon class="remove_red_eye">remove_red_eye</mat-icon>
                      </a>
                    }
                    @if (params.list.viewList) {
                      <a
                        (click)="openListModal(params.list.viewList.route, params.list.viewList.storageRoute, element)"
                        matTooltip="Ver">
                        <mat-icon class="attach_file">attach_file</mat-icon>
                      </a>
                    }
                    @if (params.list.viewMatrix) {
                      <a (click)="onViewReferenceMatrix(params.list.viewMatrix.route, element.id)"
                        matTooltip="Ver">
                        <mat-icon class="search">search</mat-icon>
                      </a>
                    }
                    @if (params.list.clone && params.list.permissions.indexOf('Incluir') >= 0) {
                      <a
                        (click)="onClickEdit(params.list.clone.route, element)" matTooltip="Clonar">
                        <mat-icon class="content_copy">content_copy</mat-icon>
                      </a>
                    }
                    @if (params.list.statusVideo) {
                      <a (click)="setOutput(params.list.statusVideo, element)"
                        matTooltip="{{ element?.attendance?.action == 'Completo' ? 'Completo' : 'Aguardando' }}">
                        <mat-icon [style.color]="element?.attendance?.action == 'Completo' ? 'green' : 'red'">{{
                        element?.attendance?.action == 'Completo' ? 'replay' : 'play_arrow' }}</mat-icon>
                      </a>
                    }
                    @if (params.list.preparationTest) {
                      <a (click)="setOutput(params.list.preparationTest, element)"
                        matTooltip="Teste de preparação">
                        <mat-icon>assignment</mat-icon>
                      </a>
                    }
                    @if (params.list.expansion) {
                      <mat-icon (click)="setOutput(params.list.expansion.action, element)"
                      matTooltip="{{params.list.expansion.tooltip}}">zoom_in</mat-icon>
                    }
                    @if (params.list.reply) {
                      <mat-icon (click)="setOutput(params.list.reply.action, element)"
                      matTooltip="{{params.list.reply.tooltip}}">reply</mat-icon>
                    }
                    @if (params.list.preview) {
                      <mat-icon (click)="setOutput(params.list.preview.action, element)"
                      matTooltip="{{params.list.preview.tooltip}}">remove_red_eye</mat-icon>
                    }
                    @if (params.list.association) {
                      <mat-icon (click)="setOutput(params.list.association.action, element)"
                        matTooltip="{{params.list.association.tooltip}}">
                      {{ params.list.association.icon ? params.list.association.icon : 'event_note'}}</mat-icon>
                    }
                    @if (params.list.version && params.list.permissions.indexOf('Incluir') >= 0) {
                      <mat-icon
                      (click)="setOutput(params.list.version, element)" class="edit" matTooltip="Clonar">content_copy</mat-icon>
                    }
                    @if (params.list.document) {
                      <a [style.color]="element?.attendance?.action == 'Completo' ? 'green' : 'red' "
                        (click)="setOutput(params.list.document, element)" matTooltip="Documento">
                        <mat-icon>save_all</mat-icon>
                      </a>
                    }
                  </mat-cell>
                </ng-container>
                @if (params.list.actionButton) {
                  <ng-container matColumnDef="entrar">
                    <mat-header-cell mat-header-cell *matHeaderCellDef> </mat-header-cell>
                    <mat-cell mat-cell *matCellDef="let element">
                      <div>
                        <div class="action-button alternative">
                          @for (btn of params.list.actionButton; track btn) {
                            <button mat-raised-button
                            (click)="setOutput(btn.value, element)" color="{{ btn.color }}">{{btn.value }}</button>
                          }
                        </div>
                      </div>
                    </mat-cell>
                  </ng-container>
                }
                <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
                <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
              </mat-table>
            }
            @if (!hidePagination && total > 10) {
              <mat-paginator
                [length]="total"
                [pageSize]="itemsPerPage"
                [pageIndex]="0"
                [pageSizeOptions]="[10, 25, 50]"
              (page)="onClickPage($event)"></mat-paginator>
            }
          </div>
        </div>
      }

    </mat-card>
  </div>
